/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiLoadSpinnerIcon16Solid = forwardRef('UiLoadSpinnerIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 3.125A4.875 4.875 0 1 0 12.875 8a1.125 1.125 0 0 1 2.25 0A7.125 7.125 0 1 1 8 .875a1.125 1.125 0 0 1 0 2.25Z" })));
});
